import { render, staticRenderFns } from "./ActivationLogByUid.vue?vue&type=template&id=a30970ac&scoped=true"
import script from "./ActivationLogByUid.vue?vue&type=script&lang=js"
export * from "./ActivationLogByUid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30970ac",
  null
  
)

export default component.exports